/* np-pudegave.js
   Bygger NordiskPuls' egen gavelinje i pude-bundlen og saetter Kachings
   __kaching_bundles-property paa kurvlinjerne, saa Kachings rabatfunktion
   giver betraekket gratis og 10% paa puderne.

   Kachings eget widget er slukket (app-embed off). Denne fil laeser kun
   deres konfiguration fra siden. Goer intet hvis konfigurationen mangler.

   Filen er ENS i tema 7.9 og 7.5. Alle farver kommer fra CSS-variabler
   som snippet'en np-pudegave.liquid saetter, saa den aldrig skal forkes.
*/
(function () {
  'use strict';

  var MAERKE = 'X-NP-Pudegave';
  var BADGE_STD = 'Mest populær';
  var BADGE_NY = 'BEDST VÆRDI';

  function log() {
    if (window.NP_PUDEGAVE_DEBUG && window.console) {
      console.log.apply(console, ['[np-pudegave]'].concat([].slice.call(arguments)));
    }
  }

  function laesJson(vaelger) {
    var el = document.querySelector(vaelger);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function gidTal(gid) {
    if (gid == null) return null;
    var m = String(gid).match(/(\d+)\s*$/);
    return m ? m[1] : null;
  }

  function kr(oere) {
    var hele = Math.round(oere / 100);
    return hele.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr';
  }

  /* ---------- konfiguration ---------- */

  var egen = laesJson('#np-pudegave-data');
  var kaching = laesJson('script.kaching-bundles-deal-block-settings');

  if (!egen || !kaching || !kaching.nanoId || !kaching.versionId) {
    log('mangler data', !!egen, !!kaching);
    return;
  }

  var DEAL = kaching.nanoId;
  var VERSION = kaching.versionId;

  // antal -> bar
  var barer = {};
  (kaching.dealBars || []).forEach(function (b) {
    if (!b || !b.id) return;
    var gaver = (b.freeGifts || []).map(function (g) {
      return {
        id: g.id,
        produktId: gidTal(g.productGID),
        antal: g.quantity || 1,
        varianter: (g.variantGIDs || []).map(gidTal)
      };
    }).filter(function (g) { return g.id && g.produktId; });
    barer[String(b.quantity)] = { id: b.id, gaver: gaver };
  });

  log('deal', DEAL, 'barer', barer);

  /* ---------- hjaelpere ---------- */

  function gaveProdukt(produktId) {
    return (egen.betraek || {})[String(produktId)] || null;
  }

  // vaelger den gavevariant der passer til den valgte pudevariant.
  // matcher paa navn (Standard -> Standard, Mini -> Mini), ellers foerste.
  function vaelgGaveVariant(gave, produkt, pudeVariantNavn) {
    var tilladte = gave.varianter && gave.varianter.length ? gave.varianter : null;
    var liste = (produkt.varianter || []).filter(function (v) {
      return !tilladte || tilladte.indexOf(String(v.id)) !== -1;
    });
    if (!liste.length) return null;
    if (pudeVariantNavn) {
      var n = String(pudeVariantNavn).trim().toLowerCase();
      for (var i = 0; i < liste.length; i++) {
        if (String(liste[i].navn).trim().toLowerCase() === n) return liste[i];
      }
    }
    return liste[0];
  }

  // produktets nuvaerende enkeltpris i oere, laest fra prisblokken
  function enkeltpris() {
    var el = document.querySelector('.np-priceblock__now');
    if (!el) return null;
    var n = parseInt(el.textContent.replace(/\D/g, ''), 10);
    return n ? n * 100 : null;
  }

  // 21/10: tæller mod det eksakte sluttidspunkt (slutTs, sat i np-pudegave.liquid),
  // med dage og timer som topperens nedtælling (np-toppergave): 10d 18t -> "10 dage og 18 timer".
  // Under et døgn vises kun timer. Teksten opdateres hvert minut (se start()).
  function tidTilbage() {
    var sek;
    if (egen.slutTs) {
      sek = egen.slutTs - Math.floor(Date.now() / 1000);
    } else if (egen.slut) {
      sek = Math.floor((new Date(egen.slut + 'T23:59:59') - new Date()) / 1000);
    } else {
      return null;
    }
    if (sek <= 0) return null;
    var dage = Math.floor(sek / 86400);
    var timer = Math.floor((sek % 86400) / 3600);
    var tTekst = timer + (timer === 1 ? ' time' : ' timer');
    if (dage >= 1) return dage + (dage === 1 ? ' dag' : ' dage') + (timer > 0 ? ' og ' + tTekst : '');
    if (timer >= 1) return tTekst;
    return 'under 1 time';
  }

  /* ---------- markup ---------- */

  var SVG_GAVE =
    '<svg class="np-pg__ikon" viewBox="3 3.7 18 18" width="14" height="14" fill="none" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M4.5 10.5h15v8.5a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5z" fill="var(--np-pg-ikonfyld)"/>' +
    '<g stroke="var(--np-pg-ikon)" stroke-width="1.5">' +
    '<path d="M4.5 10.5h15v8.5a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5z"/>' +
    '<path d="M3.5 7.5h17v3h-17z"/><path d="M12 7.5v13"/>' +
    '<path d="M12 7.5c-1.3-3-4.8-3.4-4.8-1.3S10.3 7.5 12 7.5zM12 7.5c1.3-3 4.8-3.4 4.8-1.3S13.7 7.5 12 7.5z"/>' +
    '</g></svg>';

  var SVG_UR =
    '<svg class="np-pg__ikon" viewBox="0 0 24 24" width="12" height="12" fill="none" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="9" stroke="var(--np-pg-ikon)" stroke-width="1.9"/>' +
    '<path d="M12 7.5V12l3 2" stroke="var(--np-pg-ikon)" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function byg(gave, produkt) {
    var antal = gave.antal;
    var fuld = produkt.pris * antal;
    var tid = tidTilbage();

    var html =
      '<div class="np-pg">' +
        '<div class="np-pg__linje">' +
          SVG_GAVE +
          (produkt.billede ? '<img class="np-pg__foto" src="' + produkt.billede + '" alt="" loading="lazy">' : '') +
          '<span class="np-pg__navn">' + antal + ' x ' + produkt.titel + '</span>' +
          '<span class="np-pg__pris">' +
            '<span class="np-pg__gratis">Gratis</span>' +
            '<span class="np-pg__foer">' + kr(fuld) + '</span>' +
          '</span>' +
        '</div>' +
        (tid
          ? '<div class="np-pg__timer">' + SVG_UR +
            '<span>Gratis betræk i <b>' + tid + '</b> endnu</span></div>'
          : '') +
      '</div>';

    var d = document.createElement('div');
    d.innerHTML = html;
    return d.firstChild;
  }

  /* ---------- tegn ---------- */

  function tegn() {
    var tiers = document.querySelectorAll('.np-tier[data-qty]');
    if (!tiers.length) return false;
    var maksSpar = 0;

    [].forEach.call(tiers, function (tier) {
      var antal = tier.getAttribute('data-qty');
      var bar = barer[antal];

      // ryd gammel linje
      var gl = tier.querySelector(':scope > .np-pg');
      if (gl) gl.parentNode.removeChild(gl);

      if (!bar || !bar.gaver.length) return;
      var gave = bar.gaver[0];
      var produkt = gaveProdukt(gave.produktId);
      if (!produkt) { log('ukendt gaveprodukt', gave.produktId); return; }

      var top = tier.querySelector('.np-tier__top');
      if (!top) return;
      top.parentNode.insertBefore(byg(gave, produkt), top.nextSibling);

      // Hvad sparer man ved at tage flere, ud over det tilbud der i forvejen
      // gaelder paa én? Enkeltprisen paa siden gange antallet, minus trinnets
      // pris, plus gavens vaerdi. Tier-compare duer ikke: den indeholder ogsaa
      // et evt. loebende produkttilbud, som man faar paa én pude i forvejen.
      var spar = produkt.pris * gave.antal;
      var enkelt = enkeltpris();
      var pris = tier.querySelector('.np-tier__price');
      if (enkelt && pris) {
        var trin = parseInt(pris.textContent.replace(/\D/g, ''), 10) || 0;
        var hver = enkelt * parseInt(antal, 10);
        if (hver > trin * 100) spar += hver - trin * 100;
      }
      if (spar > maksSpar) maksSpar = spar;

      // badgetekster
      var badge = tier.querySelector('.np-tier__badge');
      if (badge && badge.textContent.trim() === BADGE_STD) badge.textContent = BADGE_NY;

      var save = tier.querySelector('.np-tier__save');
      if (save) {
        var m = save.textContent.trim().match(/^SPAR\s+(\d+)\s*%/);
        if (m) save.textContent = 'SPAR ' + m[1] + '% + ' + gave.antal + ' BETRÆK';
      }
    });

    // Badge ved den store pris. Har produktet allerede et besparelsesbadge,
    // fx SPAR 20% fordi puden er sat ned, saetter vi ikke et mere ved siden af.
    // To tal om besparelse lige ved siden af hinanden slaar hinanden ihjel.
    var pb = document.querySelector('.np-priceblock');
    if (pb && maksSpar > 0) {
      pb.classList.add('np-pg-aktiv');
      if (!pb.querySelector('.np-priceblock__badge')) {
        var b = document.createElement('span');
        b.className = 'np-priceblock__badge np-priceblock__badge--pudegave';
        b.textContent = 'SPAR ' + Math.round(maksSpar / 100) + ' KR VED 2 STK';
        pb.appendChild(b);
      }
    }

    return true;
  }

  /* ---------- kurv ---------- */

  function token() {
    return Math.random().toString(36).slice(2, 10);
  }

  function hovedEgenskab(barId, tok) {
    return JSON.stringify({ deal: DEAL, pp: 1, main: true, v: VERSION, id: tok, bid: barId });
  }

  function gaveEgenskab(gaveId, tok) {
    return JSON.stringify({ id: tok, deal: DEAL, v: VERSION, gift: gaveId });
  }

  // finder det samlede antal pudelinjer i payload'en
  function beriget(payload) {
    if (!payload || !payload.items || !payload.items.length) return null;

    var pudeNavne = {};
    (egen.pudeVarianter || []).forEach(function (v) { pudeNavne[String(v.id)] = v.navn; });
    var harPude = Object.keys(pudeNavne).length > 0;

    var pudelinjer = payload.items.filter(function (i) {
      return !harPude || pudeNavne.hasOwnProperty(String(i.id));
    });
    if (!pudelinjer.length) return null;

    var antal = pudelinjer.reduce(function (s, i) { return s + (i.quantity || 1); }, 0);
    var bar = barer[String(antal)];
    if (!bar || !bar.gaver.length) return null;

    // staar der allerede en kaching-property, roerer vi ikke ved den
    for (var i = 0; i < payload.items.length; i++) {
      var pr = payload.items[i].properties;
      if (pr && pr.__kaching_bundles) return null;
    }

    var tok = token();
    pudelinjer.forEach(function (it) {
      it.properties = it.properties || {};
      it.properties.__kaching_bundles = hovedEgenskab(bar.id, tok);
    });

    // Hvilke pudevarianter valgte kunden, og hvor mange af hver?
    // Paa KoelePuden kan man vaelge Standard og Mini paa hver sin plads,
    // og saa skal betraekkene matche én til én.
    var valgte = [];
    pudelinjer.forEach(function (it) {
      var n = pudeNavne[String(it.id)];
      for (var k = 0; k < (it.quantity || 1); k++) valgte.push(n);
    });

    bar.gaver.forEach(function (gave) {
      var produkt = gaveProdukt(gave.produktId);
      if (!produkt) return;

      // Gaven foelger pudernes stoerrelser, naar der er lige mange af hver.
      // Ellers én samlet linje paa den foerste tilladte variant.
      var navne = gave.antal === valgte.length ? valgte : [null];
      var pr = {};
      navne.forEach(function (n) {
        var v = vaelgGaveVariant(gave, produkt, n);
        if (!v) return;
        pr[v.id] = (pr[v.id] || 0) + (navne.length === 1 ? gave.antal : 1);
      });

      Object.keys(pr).forEach(function (vid) {
        payload.items.push({
          id: parseInt(vid, 10),
          quantity: pr[vid],
          properties: { __kaching_bundles: gaveEgenskab(gave.id, tok) }
        });
      });
    });

    log('beriget', payload);
    return payload;
  }

  var ORIG_FETCH = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var metode = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();

      if (metode === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
        var allerede = init.headers && (init.headers[MAERKE] || (init.headers.get && init.headers.get(MAERKE)));
        if (!allerede) {
          var data = JSON.parse(init.body);
          var ny = beriget(data);
          if (ny) {
            init = Object.assign({}, init, { body: JSON.stringify(ny) });
            init.headers = Object.assign({}, init.headers || {});
            init.headers[MAERKE] = '1';
          }
        }
      }
    } catch (e) {
      log('fetch-fejl, sender uaendret', e);
    }
    return ORIG_FETCH.apply(this, arguments.length > 1 ? [input, init] : [input]);
  };

  /* ---------- start ---------- */

  function opdaterTimer() {
    var tid = tidTilbage();
    [].forEach.call(document.querySelectorAll('.np-pg__timer'), function (el) {
      if (!tid) { el.parentNode.removeChild(el); return; }
      var b = el.querySelector('b');
      if (b && b.textContent !== tid) b.textContent = tid;
    });
  }

  function start() {
    setInterval(opdaterTimer, 60000);
    if (tegn()) return;
    var forsoeg = 0;
    var t = setInterval(function () {
      forsoeg++;
      if (tegn() || forsoeg > 20) clearInterval(t);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
